/**
 * Signature cocktail enrichment — detail content + uploaded image assets,
 * keyed by nkey(name) so backend rows merge cleanly.
 */
import { nkey } from "./menuData";

const IMG = "/cocktails";

export const BRIDE_TONE = "#be185d";
export const GROOM_TONE = "#1d4ed8";

export const COCKTAIL_DETAILS = {
  french75: {
    name: "French 75",
    image: `${IMG}/french-75.jpg`,
    recommendation: "Bride Recommendation",
    description:
      "A timeless French cocktail dating back to World War I. Bright citrus and sparkling wine make it elegant, crisp, and perfect for celebrations.",
    flavor: "Bright, citrusy, bubbly, and refreshing.",
    ingredients: ["Gin", "Fresh Lemon Juice", "Simple Syrup", "Champagne"],
    alcoholic: true,
  },
  lycheespritz: {
    name: "Lychee Spritz",
    // Per-image display config: keep the whole glass visible in the detail
    // modal (letterboxed) instead of an aggressive crop. Same master asset
    // as the Home thumbnail.
    display: { fit: "contain", bg: "#e9e4f4" },
    image: `${IMG}/lychee-spritz.jpg`,
    recommendation: "Bride Recommendation",
    description:
      "A refreshing sparkling mocktail inspired by tropical lychee fruit. Floral, lightly sweet, and crisp with a citrus finish.",
    flavor: "Floral, lightly sweet, sparkling, and refreshing.",
    ingredients: ["Lychee Juice", "Sparkling Water", "Lemon", "Mint"],
    alcoholic: false,
  },
  moscowmule: {
    name: "Moscow Mule",
    image: `${IMG}/moscow-mule.jpg`,
    recommendation: "Groom Recommendation",
    description:
      "Created in the 1940s and traditionally served in a copper mug, the Moscow Mule combines vodka, ginger beer, and fresh lime into a crisp, refreshing classic.",
    flavor: "Crisp, citrusy, gingery, and slightly spicy.",
    ingredients: ["Vodka", "Ginger Beer", "Fresh Lime Juice"],
    alcoholic: true,
  },
  suero: {
    name: "Suero",
    image: `${IMG}/suero.jpg`,
    recommendation: "Groom Recommendation",
    description:
      "A refreshing Dominican favorite combining lime and sparkling water into a clean, citrus-forward drink that is perfect for warm evenings.",
    flavor: "Light, salty, citrus-forward, and highly refreshing.",
    ingredients: ["Fresh Lime Juice", "Sparkling Water", "Ice", "Optional Salt Rim"],
    alcoholic: false,
  },
};

// Display order: French 75, Lychee Spritz / Moscow Mule, Suero
export const COCKTAIL_ORDER = ["french75", "lycheespritz", "moscowmule", "suero"];

export function recommendationTone(rec) {
  return (rec || "").toLowerCase().startsWith("bride") ? BRIDE_TONE : GROOM_TONE;
}

// Merge static detail content with the matching backend cocktail row (if any).
export function buildCocktailList(backendCocktails) {
  const byKey = {};
  (backendCocktails || []).forEach((c) => { byKey[nkey(c.name)] = c; });
  return COCKTAIL_ORDER.map((k) => {
    const detail = COCKTAIL_DETAILS[k];
    const backend = byKey[k] || {};
    return { key: k, id: backend.id || k, ...detail };
  });
}
